import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  requestUserUpdate,
  requestExport,
  requestUserPackage,
  requestUserTariff,
  requestSendNotification, requestAddBonus
} from "actions/users/requests";

import {
  USERS_LOADING,
  USERS_ERROR,

  USERS_GET_LIST,
  USERS_GET_FILTERS,
  USERS_GET_SINGLE,
  USERS_UPDATE_SINGLE,
  USERS_UPDATE_PACKAGE,
  USERS_UPDATE_TARIFF
} from "actions/users/constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";
import filterTypes from "../../data/filter-types";

export const setLoading = (status) => ({
  type: USERS_LOADING,
  payload: status
});

export const getUsersList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("user", page, size, sort, filters)
    .then(response => {
      dispatch({
        type: USERS_GET_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};

export const getUsersFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("user")
    .then((response) => {
      dispatch({
        type: USERS_GET_FILTERS,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};

export const setUserData = (data) => dispatch => {
  dispatch(setLoading(true));
  requestUserUpdate(data)
    .then(() => {
      dispatch({
        type: USERS_UPDATE_SINGLE,
        payload: data
      });
      toast("User data updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};

export const exportUsers = (filters = [], callback) => dispatch => {
  dispatch(setLoading(true));
  requestExport(filters)
    .then(response => {
      callback(response.data);
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};

export const sendNotification = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  requestSendNotification(data)
    .then(() => {
      callback(true);
      dispatch(setLoading(false));
      toast("Notification sent successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(() => {
      callback(false);
      dispatch(setLoading(false));
    });
};

export const getSingleUser = (userId) => dispatch => {
  requestCommonSearch("user", 0, 1, "id,asc", [{
    fieldName: "id",
    fieldValue: userId,
    searchOperation: filterTypes.EQUALS.value
  }])
    .then(response => {
      dispatch({
        type: USERS_GET_SINGLE,
        payload: response.content && response.content[0]
          ? response.content[0]
          : {}
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};

export const resetSingleUser = () => dispatch => {
  dispatch({
    type: USERS_GET_SINGLE,
    payload: {}
  });
};

export const updatePackage = (userId, pack) => dispatch => {
  requestUserPackage(userId, pack.id)
    .then(() => {
      dispatch({
        type: USERS_UPDATE_PACKAGE,
        payload: {
          userId,
          package: pack
        }
      });
      toast("Package added successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};

export const updateTariff = (userId, tariff, until) => dispatch => {
  requestUserTariff(userId, tariff.id, until)
    .then(() => {
      dispatch({
        type: USERS_UPDATE_TARIFF,
        payload: {
          userId,
          tariff,
          until
        }
      });
      toast("Tariff added successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};

export const addBonus = (payload) => dispatch => {
  requestAddBonus(payload)
    .then(() => {
      toast("Bonus added successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, USERS_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/users/actions.js